import { render } from "./DockedChat.vue?vue&type=template&id=cba62d3e"
import script from "./DockedChat.vue?vue&type=script&lang=js"
export * from "./DockedChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/chat/DockedChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cba62d3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cba62d3e', __exports__)) {
    api.reload('cba62d3e', __exports__)
  }
  
  module.hot.accept("./DockedChat.vue?vue&type=template&id=cba62d3e", () => {
    api.rerender('cba62d3e', render)
  })

}


export default __exports__